import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Note mdxType="Note">
      <p>{`The below instructions are provided for reference only. Beginning in April 2024, Apollo recommends that all organizations use the `}<a parentName="p" {...{
          "href": "#setup"
        }}>{`updated instructions`}</a>{` to create a new SSO connection.`}</p>
      <p>{`To use `}<a parentName="p" {...{
          "href": "/graphos/org/sso/multi-organization"
        }}>{`multi-organization SSO`}</a>{`, your SSO connection cannot use PingOne as shown in the legacy instructions below.
Follow the `}<a parentName="p" {...{
          "href": "#setup"
        }}>{`updated instructions`}</a>{` to create a new SSO connection.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      